import * as scoket from "socket.io-client";
import mediasoup, { types, Device } from "mediasoup-client";
import { EventEmitter } from "events";
import * as mediasoupClient from "mediasoup-client";
import socket from "./web-socket";

import {
  addConsumer,
  addProducers,
  closeProducers,
  joiningRoom,
  pauseProducer,
  removeConsumer,
  removeProducers,
  resumeProducer,
  roomSignInError,
  store,
  updateIsRoomLoading,
  updateRoomStatusMessage,
  resetRoomSettings,
  addUsersToRoom,
  setUserRaisedHand,
  setUserDropHand,
  removeUserFromRoom,
  youHaveBeenKickedOut,
  mutedByAdminToggle,
  updateUserToSpeaker,
  temporarySpeakerUpdate,
  removeUserAsSpeaker,
  youHaveBeenBlocked,
  setjoinRoom,
  setNewNotification,
  updateisSpeaking,
  updateMicSetting,
} from "../app/store";
import { userInfo } from "../globalComponents/slice/userDataSlice";
import { apolloClient } from "./graphql";
import { GET_USER } from "./apollo";
import { NotificationAlert } from "../utils/NotificationAlert";

const mediaType = {
  audio: "audioType",
  video: "videoType",
  screen: "screenType",
};
console.log("reinited");
const _EVENTS = {
  exitRoom: "exitRoom",
  openRoom: "openRoom",
  startVideo: "startVideo",
  stopVideo: "stopVideo",
  startAudio: "startAudio",
  stopAudio: "stopAudio",
  startScreen: "startScreen",
  stopScreen: "stopScreen",
};

export class RoomClient extends EventEmitter {
  name: any;
  localMediaEl: any;
  remoteVideoEl: any;
  remoteAudioEl: any;
  mediasoupClient: any;
  socket: any;
  producerTransport: types.Transport | null;
  consumerTransport: types.Transport | null;
  device: types.Device;
  room_id: any;
  user_id: any;
  // consumers: Map<any, any>;
  // producers: Map<any, any>;
  producerLabel: Map<any, any>;
  _isOpen: boolean;
  eventListeners: Map<any, any>;
  testCounter: number;

  /**
   *
   * @param localMediaEl this parameter takes an html element ref
   * @param remoteVideoEl this parameter takes an html element ref
   * @param remoteAudioEl this parameter takes an html element ref
   * @param mediasoupClient mediasoupClient
   * @param socket socket.io instance
   * @param room_id a unique id for users to join
   * @param user_id a unique id for users to join
   * @param name Users name
   * @param successCallback a function that is called after a successful connection
   * @param isProducer a boolean value to let a user joins as a speaker if true
   *
   */

  constructor({
    localMediaEl,
    remoteVideoEl,
    remoteAudioEl,
    // mediasoupClient,
    socket,
    name,
    isProducer,
  }: {
    localMediaEl: any;
    remoteVideoEl: any;
    remoteAudioEl: any;
    // mediasoupClient: typeof mediasoup;
    socket: scoket.Socket;
    name: string;
    isProducer: boolean;
  }) {
    console.log("started");
    super();
    this.name = name;
    this.localMediaEl = localMediaEl;
    this.remoteVideoEl = remoteVideoEl;
    this.remoteAudioEl = remoteAudioEl;
    this.mediasoupClient = mediasoupClient;

    this.socket = socket;
    this.producerTransport = null;
    this.consumerTransport = null;
    //@ts-ignore
    this.device = null;
    this.testCounter = 0;

    // this.consumers = new Map();
    // this.producers = new Map();

    /**
     * map that contains a mediatype as key and producer_id as value
     */
    this.producerLabel = new Map();

    this._isOpen = false;
    console.log("called constructor again")
    this.eventListeners = new Map();
    Object.keys(_EVENTS).forEach((evt) => {
      this.eventListeners.set(evt, []);
    });
  }

  ////////// INIT /////////
  incCounter(){
    this.testCounter ++
    console.log(this.testCounter)
  }

  async startJoinProcess() {
    console.log("about to join");
    this.createRoom(this.room_id)
      .then(async () => {
        // await this.join(this.name, this.room_id);
        await this.initSockets();
        this._isOpen = true;
        // this.successCallback();
        await setTimeout(() => {
          // const that = this;
          // if (that.isProducer) {
          //   this.produce(mediaType.audio);
          // }
        }, 5000);
      })
      .catch((err) => console.log(err, "server error"));
  }

  async createRoom(room_id: string) {
    console.log("inside create room");
    await this.socket
      .request("createRoom", {
        room_id,
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  async join(
    name: string,
    room_id: string,
    user_id: string,
    token: string,
    isSpeaker: boolean
  ) {
    this.room_id = room_id;
    this.user_id = user_id
    store.dispatch(joiningRoom({}));
    const data = await this.socket.request("getRouterRtpCapabilities", {
      room_id,
    });
    let device = await this.loadDevice(data);
    await this.initSockets();
    this.device = device;
    this.socket
      .request("join", {
        name,
        room_id,
        user_id,
        token,
        rtpCapabilities: device.rtpCapabilities,
        sctpCapabilities: device.sctpCapabilities,
        isSpeaker,
      })
      .then(async (e: any) => {
        console.log(e, "join info");
        console.log("after join info");
        if (!e?.isError) {
          await this.initTransports(device);
          this.addMultipleUsersToStore(e.users);
          this.emit("joinedRoomAndConnected");
          this._isOpen = true;
          store.dispatch(setjoinRoom(true));
          store.dispatch(updateIsRoomLoading(false));
          store.dispatch(updateRoomStatusMessage("Connected"));
        } else {
          console.log(e);
        }
      })
      .catch((e: any) => {
        NotificationAlert("error", "Error", e.error);
        console.log(e, "error info");
        console.log("error occuired");
        store.dispatch(roomSignInError({}));
      });
  }

  private async loadDevice(routerRtpCapabilities: types.RtpCapabilities) {
    let device;
    console.log(this.mediasoupClient);
    try {
      device = await new this.mediasoupClient.Device();
      console.log(device, "lddr");
    } catch (error) {
      if (error.name === "UnsupportedError") {
        console.error("browser not supported");
      }
      console.error(error);
    }
    console.log(device);
    await device.load({
      routerRtpCapabilities,
    });
    return device;
  }

  private async createWebRtcTransport(
    device: types.Device
  ): Promise<types.TransportOptions | undefined> {
    const data = await this.socket.request("createWebRtcTransport", {
      forceTcp: false,
      rtpCapabilities: device.rtpCapabilities,
    });
    console.log("create web transport", data);
    if (data.error) {
      console.error(data.error, "error");
      return;
    }
    return data;
  }

  /**
   *
   * @param device
   * @returns
   * Function to create transport to receive and send stream
   */
  private async initTransports(device: types.Device) {
    // init producerTransport
    {
      // CONFIG From server;
      const data = await this.createWebRtcTransport(device);

      if (!data) {
        console.log("unable to create transport");
        return;
      }
      // Transport to send Stream
      this.producerTransport = device.createSendTransport(data);
      this.producerTransport.on(
        "connect",
        async (
          { dtlsParameters }: { dtlsParameters: types.DtlsParameters },
          callback: any,
          errback: any
        ) => {
          console.log("producer Transport send");
          this.socket
            .request("connectTransport", {
              dtlsParameters,
              transport_id: data.id,
              isConsumerTransport: false,
            })
            .then(callback)
            .catch(errback);
        }
      );

      this.producerTransport.on(
        "produce",
        async (
          {
            kind,
            rtpParameters,
          }: { kind: string; rtpParameters: types.RtcpParameters },
          callback: any,
          errback: any
        ) => {
          try {
            const { producer_id } = await this.socket.request("produce", {
              producerTransportId: this.producerTransport?.id,
              kind,
              rtpParameters,
            });
            callback({
              id: producer_id,
            });
          } catch (err) {
            errback(err);
          }
        }
      );

      this.producerTransport.on("connectionstatechange", (state: any) => {
        switch (state) {
          case "connecting":
            break;

          case "connected":
            //localVideo.srcObject = stream
            break;

          case "failed":
            this.producerTransport?.close();
            break;

          default:
            break;
        }
      });
    }

    // init consumerTransport
    {
      const data = await this.socket.request("createWebRtcTransport", {
        forceTcp: false,
      });
      if (data.error) {
        console.error(data.error);
        return;
      }

      // Single Transport createed to receive streams
      this.consumerTransport = device.createRecvTransport(data);
      this.consumerTransport.on(
        "connect",
        (
          { dtlsParameters }: { dtlsParameters: types.DtlsParameters },
          callback: any,
          errback: any
        ) => {
          console.log("send consumer transport id", this.consumerTransport?.id);
          this.socket
            .request("connectTransport", {
              transport_id: this.consumerTransport?.id,
              dtlsParameters,
              isConsumerTransport: true,
            })
            .then(callback)
            .catch(errback);
        }
      );

      this.consumerTransport.on("connectionstatechange", async (state: any) => {
        switch (state) {
          case "connecting":
            break;

          case "connected":
            //remoteVideo.srcObject = await stream;
            //await socket.request('resume');
            break;

          case "failed":
            this.consumerTransport?.close();
            break;

          default:
            break;
        }
      });
    }
    //  Send Users transports to the server
    this.socket
      .request("updateTransportsId", {
        consumerTransport: this.consumerTransport.id,
        producerTransport: this.producerTransport.id,
      })
      .then((cb: unknown) => {
        this.processConsumers();
      });
  }
  /**
   *
   * Get avaliable streams from producers in a room
   *
   */
  private async processConsumers() {
    const datat = await this.socket.request("processConsumers", {
      room_id: this.room_id,
    });
    datat.data.forEach((element: unknown) => {
      this.addStreamToTrack(element);
    });
  }

  /**
   * Sockets Methods
   */
  private initSockets() {
    const that = this
    this.socket.on(
      "consumerClosed",
      ({ consumer_id }: { consumer_id: string }) => {
        console.log("closing consumer:", consumer_id);
        this.removeConsumer(consumer_id);
      }
    );

    this.socket.on("userRaiseHand", ({ user_id }: { user_id: string }) => {
      console.log("user raise hand", user_id);
      const user =
        store.getState().room.usersInRoom[user_id];
      store.dispatch(
        setNewNotification({type:'NOTICE', message:`${user?.firstname || "user" } ${user?.lastname || ""} raise hand.`})
      );
      store.dispatch(setUserRaisedHand({ id: user_id }));
    });

    this.socket.on("newUser", async (user: any) => {
      await this.addUserInRoomToStore(user);
      const userX =
      store.getState().room.usersInRoom[user.id];
        store.dispatch(setNewNotification({type:'NOTICE', message:`${userX?.firstname || "user" } ${userX?.lastname || ""} joined.`}));
    });
    
    this.socket.on("getReaction", async ({reaction,user_id}:{reaction:any,user_id:string}) => {
      const user =
      store.getState().room.usersInRoom[user_id];
        store.dispatch(setNewNotification({type:'REACTION', message:`${user?.firstname || "user" } ${user?.lastname || ""} ${reaction} ${reaction} ${reaction} ${reaction}`}));
    });

    this.socket.on("userExit", (user_id: string) => {
      console.log("userExit", user_id);
      const user =
        store.getState().room.usersInRoom[user_id];
      store.dispatch(
        setNewNotification({type:'NOTICE', message:`${user?.firstname || "user" } ${user?.lastname || ""} left the group`})
      );
      store.dispatch(removeUserFromRoom({ id: user_id }));
    });

    this.socket.on("userKickedOut", (user_id: string) => {
      const user =
        store.getState().room.usersInRoom[user_id];
      store.dispatch(
        setNewNotification({type:'NOTICE', message:`${user?.firstname || "user" } ${user?.lastname || ""} has been kicked out`})
      );
      if (String(user_id) === String(this.user_id)) {
        store.dispatch(youHaveBeenKickedOut());
        this.exit()
      }
    });

    this.socket.on("userBlocked", (user_id: string) => {
      const user =
        store.getState().room.usersInRoom[user_id];
      store.dispatch(
        setNewNotification({type:'NOTICE', message:`${user?.firstname || "user" } ${user?.lastname || ""} has been blocked`})
      );
      if (String(user_id) === String(this.user_id)) {
        store.dispatch(youHaveBeenBlocked());
        this.exit()
      }
    });

    this.socket.on("muteToggleByAdmin", (user_id: string, status: boolean) => {
      console.log(user_id, "muted by admin");
      const user =
        store.getState().room.usersInRoom[user_id];
      store.dispatch(
        setNewNotification(
          {type:'NOTICE', message:`${user?.firstname || "user" } ${user?.lastname || ""} has been muted by THE MODERATOR`}
        )
      );
      if (String(user_id) === String(this.user_id)) {
        store.dispatch(mutedByAdminToggle(status));
      }
    });

    this.socket.on("addSpeaker", (user_id: string) => {
      console.log("add speaker response", user_id);
      const user =
        store.getState().room.usersInRoom[user_id];
      store.dispatch(
        setNewNotification(
          {type:'NOTICE', message:`${user?.firstname || "user" } ${user?.lastname || ""} has been added as a speaker`}
        )
      );
      store.dispatch(updateUserToSpeaker({ id: user_id }));
      if (String(user_id) === String(that.user_id)) {
        console.log("its me")
        store.dispatch(temporarySpeakerUpdate(true));
      }
    });

    this.socket.on("removeSpeaker", (user_id: string) => {
      console.log("removeSpeaker back kk")
      const user =
        store.getState().room.usersInRoom[user_id];
      store.dispatch(
        setNewNotification(
          {type:'NOTICE', message:`${user?.firstname || "user" } ${user?.lastname || ""} has been been removed as a speaker`}
        )
      );
      store.dispatch(removeUserAsSpeaker({ id: user_id }));
      console.log("object user id 1",user_id)
      console.log("object user id 2", that.user_id)
      console.log("object user id tht", that)

      if (String(user_id) === String(that.user_id)) {
        this.closeProducer("audioType")
        store.dispatch(temporarySpeakerUpdate(false));
      }
    });

    this.socket.on("userDropHand", ({ user_id }: { user_id: string }) => {
      console.log("user drop hand", user_id);
      store.dispatch(setUserDropHand({ id: user_id }));
    });

    this.socket.on("newProducers", async (data: any) => {
      console.log("new producers", data);

      for (let { producer_id } of data) {
        await this.consume(producer_id);
      }
    });

    this.socket.on("disconnect", () => {
      this.exit(true);
    });
  }

  //////// MAIN FUNCTIONS /////////////

  /**
   *
   * @param type
   * @param deviceId
   * @returns
   * Function to join as a speaker in a room
   *
   */
  async produce(type: string, deviceId = null) {
    let mediaConstraints = {};
    let audio = false;
    let screen = false;
    switch (type) {
      case mediaType.audio:
        mediaConstraints = {
          audio: {
            deviceId: deviceId,
          },
          video: false,
        };
        audio = true;
        break;
      case mediaType.video:
        mediaConstraints = {
          audio: false,
          video: {
            width: {
              min: 640,
              ideal: 1920,
            },
            height: {
              min: 400,
              ideal: 1080,
            },
            deviceId: deviceId,
            /*aspectRatio: {
                            ideal: 1.7777777778
                        }*/
          },
        };
        break;
      case mediaType.screen:
        mediaConstraints = false;
        screen = true;
        break;
      default:
        return;
        break;
    }
    if (!this.device.canProduce("video") && !audio) {
      console.error("cannot produce video");
      return;
    }
    if (this.producerLabel.has(type)) {
      console.log("producer already exists for this type " + type);
      return;
    }
    let stream;
    try {
      // @ts-ignore
      stream = screen
        ? // @ts-ignore
          await navigator.mediaDevices?.getDisplayMedia?.()
        : // @ts-ignore
          await navigator.mediaDevices?.getUserMedia(mediaConstraints);
      // console.log(navigator.mediaDevices.getSupportedConstraints())
      const track = audio
        ? stream.getAudioTracks()[0]
        : stream.getVideoTracks()[0];
      const params: any = {
        track,
      };
      if (!audio && !screen) {
        params.encodings = [
          {
            rid: "r0",
            maxBitrate: 100000,
            //scaleResolutionDownBy: 10.0,
            scalabilityMode: "S1T3",
          },
          {
            rid: "r1",
            maxBitrate: 300000,
            scalabilityMode: "S1T3",
          },
          {
            rid: "r2",
            maxBitrate: 900000,
            scalabilityMode: "S1T3",
          },
        ];
        params.codecOptions = {
          videoGoogleStartBitrate: 1000,
        };
      }
      const producer = await this.producerTransport?.produce(params);

      console.log("producer", producer);
      if (producer) {
        store.dispatch(addProducers({ id: producer.id, value: producer }));
        store.dispatch(updateisSpeaking(true));
        store.dispatch(updateMicSetting(false));
        
      }
      // this.producers.set(producer.id, producer);

      let elem: any;
      if (!audio) {
        elem = document.createElement("video");
        elem.srcObject = stream;
        elem.id = producer?.id;
        elem.playsInline = false;
        elem.autoplay = true;
        elem.className = "vid";
        this.localMediaEl.appendChild(elem);
      }

      producer?.on("trackended", () => {
        this.closeProducer(type);
      });

      producer?.on("transportclose", () => {
        console.log("producer transport close");
        if (!audio) {
          elem.srcObject.getTracks().forEach(function (track: any) {
            track.stop();
          });
          elem.parentNode.removeChild(elem);
        }
        store.dispatch(removeProducers({ id: producer.id }));
        // this.producers.delete(producer.id);
      });

      producer?.on("close", () => {
        console.log("closing producer");
        if (!audio) {
          elem.srcObject.getTracks().forEach(function (track: any) {
            track.stop();
          });
          elem.parentNode.removeChild(elem);
        }
        // this.producers.delete(producer.id);
        store.dispatch(removeProducers({ id: producer.id }));
      });

      this.producerLabel.set(type, producer?.id);

      switch (type) {
        case mediaType.audio:
          this.event(_EVENTS.startAudio);
          break;
        case mediaType.video:
          this.event(_EVENTS.startVideo);
          break;
        case mediaType.screen:
          this.event(_EVENTS.startScreen);
          break;
        default:
          return;
          break;
      }
    } catch (err) {
      console.log(err);
    }
  }

  private async addStreamToTrack(data: any) {
    console.log(data, "stream data");
    let codecOptions = {};

    await this.consumerTransport
      ?.consume({
        id: data.id,
        producerId: data.producerId,
        kind: data.kind,
        rtpParameters: data.rtpParameters,
        // codecOptions,
      })
      .then((consumer: any) => {
        console.log(consumer);
        const stream = new MediaStream();
        stream.addTrack(consumer.track);
        store.dispatch(addConsumer({ id: consumer.id, value: consumer }));
        // this.consumers.set(consumer.id, consumer);

        let elem;
        if (data.kind === "video") {
          elem = document.createElement("video");
          elem.srcObject = stream;
          elem.id = consumer.id;
          elem.playsInline = false;
          elem.autoplay = true;
          elem.className = "vid";
          this.remoteVideoEl.appendChild(elem);
        } else {
          const voice = document.getElementById("voice");
          console.log("inside audio", voice);
          elem = document.createElement("audio");
          elem.srcObject = stream;
          elem.id = consumer.id;
          //@ts-ignore
          elem.playsInline = false;
          elem.autoplay = true;
          voice?.appendChild(elem);
        }

        consumer.on("trackended", () => {
          this.removeConsumer(consumer.id);
        });

        consumer.on("transportclose", () => {
          this.removeConsumer(consumer.id);
        });
      });
  }

  private async consume(producer_id: string) {
    console.log("data to consume", producer_id);
    this.getConsumeStream(producer_id).then(
      ({ consumer, stream, kind }: any) => {
        console.log(consumer);
        store.dispatch(addConsumer({ id: consumer.id, value: consumer }));
        // this.consumers.set(consumer.id, consumer);

        let elem;
        if (kind === "video") {
          elem = document.createElement("video");
          elem.srcObject = stream;
          elem.id = consumer.id;
          elem.playsInline = false;
          elem.autoplay = true;
          elem.className = "vid";
          this.remoteVideoEl.appendChild(elem);
        } else {
          const voice = document.getElementById("voice");
          console.log("inside audio", voice);
          elem = document.createElement("audio");
          elem.srcObject = stream;
          elem.id = consumer.id;
          //@ts-ignore
          elem.playsInline = false;
          elem.autoplay = true;
          voice?.appendChild(elem);
        }

        consumer.on("trackended", () => {
          this.removeConsumer(consumer.id);
        });
        consumer.on("transportclose", () => {
          this.removeConsumer(consumer.id);
        });
      }
    );
  }

  private async getConsumeStream(producerId: string) {
    console.log(producerId, "producerId");
    const { rtpCapabilities } = this.device;
    const data = await this.socket.request("consume", {
      rtpCapabilities,
      consumerTransportId: this.consumerTransport?.id, // might be
      producerId,
    });
    const { id, kind, rtpParameters } = data;
    console.log(data, "compare id");

    let codecOptions = {};
    const consumer = await this.consumerTransport?.consume({
      id,
      producerId,
      kind,
      rtpParameters,
      // codecOptions,
    });
    const stream = new MediaStream();
    if (consumer) {
      stream.addTrack(consumer.track);
    }
    return {
      consumer,
      stream,
      kind,
    };
  }

  closeProducer(type: string) {
    if (!this.producerLabel.has(type)) {
      console.log("there is no producer for this type " + type);
      return;
    }
    let producer_id = this.producerLabel.get(type);
    console.log(producer_id);
    this.socket.emit("producerClosed", {
      producer_id,
    });
    // this.producers.get(producer_id).close();
    store.dispatch(closeProducers({ id: producer_id }));
    store.dispatch(removeProducers({ id: producer_id }));
    // this.producers.delete(producer_id);

    this.producerLabel.delete(type);

    if (type !== mediaType.audio) {
      let elem = document.getElementById(producer_id);
      console.log(elem);
      // elem?.srcObject.getTracks().forEach(function (track) {
      //     track.stop()
      // })
      // elem.parentNode.removeChild(elem)
    }

    switch (type) {
      case mediaType.audio:
        this.event(_EVENTS.stopAudio);
        break;
      case mediaType.video:
        this.event(_EVENTS.stopVideo);
        break;
      case mediaType.screen:
        this.event(_EVENTS.stopScreen);
        break;
      default:
        return;
        break;
    }
  }

  pauseProducer(type: string) {
    if (!this.producerLabel.has(type)) {
      console.log("there is no producer for this type " + type);
      return;
    }
    let producer_id = this.producerLabel.get(type);
    store.dispatch(pauseProducer({ id: producer_id }));
    store.dispatch(updateMicSetting(true));
    // this.producers.get(producer_id).pause();
  }

  resumeProducer(type: string) {
    if (!this.producerLabel.has(type)) {
      console.log("there is no producer for this type " + type);
      return;
    }
    let producer_id = this.producerLabel.get(type);
    store.dispatch(resumeProducer({ id: producer_id }));
    store.dispatch(updateMicSetting(false));
    // this.producers.get(producer_id).resume();
  }

  removeConsumer(consumer_id: string) {
    const elem: any = document.getElementById(consumer_id);
    elem?.srcObject?.getTracks()?.forEach(function (track: any) {
      track.stop();
    });
    elem?.parentNode?.removeChild(elem);

    store.dispatch(removeConsumer({ id: consumer_id }));
    // this.consumers.delete(consumer_id);
  }

  ///////// ADMIN FUNCTIONS ////////
  adminMuteSpeaker(user_id: string, status: string): void {
    this.socket.request("adminMuteSpeaker", { user_id, status });
  }

  adminKickOutUser(user_id: string): void {
    this.socket.request("adminKickOutUser", { user_id });
  }

  adminBlockUser(user_id: string): void {
    this.socket.request("adminBlockUser", { user_id });
  }

  adminAddUserAsSpeaker(user_id: string): void {
    this.socket.request("adminAddUserAsSpeaker", { user_id });
  }

  adminRemoveUserAsSpeaker(user_id: string): void {
    console.log("remove user")
    this.socket.request("adminRemoveUserAsSpeaker", { user_id });
  }

  dropHand(): void {
    this.socket.request("dropHand", () => {});
  }

  raiseHand(): void {
    this.socket.request("raiseHand", () => {});
  }

  exit(offline = false) {
    let clean = () => {
      this._isOpen = false;
      this.consumerTransport?.close();
      this.producerTransport?.close();
      this.room_id = "";
      this.socket.off("disconnect");
      this.socket.off("newProducers");
      this.socket.off("consumerClosed");
    };
    store.dispatch(resetRoomSettings());
    if (!offline) {
      this.socket
        .request("exitRoom")
        .then((e: any) => console.log(e))
        .catch((e: any) => console.warn(e))
        .finally(
          function () {
            clean();
          }.bind(this)
        );
    } else {
      clean();
    }

    this.event(_EVENTS.exitRoom);
  }

  ///////  HELPERS //////////
  //////// HELPERS ////////

  async roomInfo() {
    let info = await this.socket.request("getMyRoomInfo");
    return info;
  }

  static get mediaType() {
    return mediaType;
  }

  event(evt: any) {
    if (this.eventListeners.has(evt)) {
      this.eventListeners.get(evt).forEach((callback: any) => callback());
    }
  }

  //   on(evt, callback) {
  //     this.eventListeners.get(evt).push(callback);
  //   }

  private addMultipleUsersToStore(
    users: { id: string; isSpeaker: boolean; isHandRaised: boolean }[]
  ) {
    users.forEach((user) => {
      this.addUserInRoomToStore(user);
    });
  }

  private async addUserInRoomToStore(user: {
    id: string;
    isSpeaker: boolean;
    isHandRaised: boolean;
  }) {
   await apolloClient
      .query({
        query: GET_USER,
        variables: {
          id: user.id,
        },
      })
      .then((resp) => {
        if (resp.data?.user) {
          store.dispatch(
            addUsersToRoom([
              {
                id: user.id,
                isHandRaised: user.isHandRaised,
                firstname: resp.data?.user.firstname,
                lastname: resp.data?.user.lastname,
                picture: resp.data?.user.photolink,
                isSpeaker: user.isSpeaker,
              },
            ])
          );
        }
      });
  }

  toggleReactionContainer(){
    const item = document.getElementById("reaction-container")
    if(!item?.classList.contains("show-reaction")){
      item?.classList.add("show-reaction")
    }else{
      item?.classList.remove("show-reaction")
    }
  }

  sendReaction(item:any){
    this.socket.emit("sendReaction", {reaction:item})
  }

  //////// GETTERS ////////

   get isOpen() {
    return this._isOpen;
  }

  get roomId() {
    return this.room_id;
  }

  static get EVENTS() {
    return _EVENTS;
  }
}

 const Room = new RoomClient({
  isProducer: false,
  name: "Michael",
  socket,
  localMediaEl: document.getElementById("voice"),
  remoteAudioEl: document.querySelector("#voice"),
  remoteVideoEl: document.getElementById("voice"),
});

export default Room